import isEqualWith from "lodash/isEqualWith";
import isFunction from "lodash/isFunction";
import { isValidElement } from "react";
import isEqual from "react-fast-compare";
const hasFn = (obj, fn) => obj && obj[fn] && isFunction(obj[fn]);
const hasEquals = (obj) => hasFn(obj, "equals");
const isImmutable = (obj) => hasFn(obj, "toJS");
const _isEqual = (first, second) => {
  if (isImmutable(first) && isImmutable(second)) {
    return isEqualWith(first.toJS(), second.toJS(), _isEqual);
  }
  if (hasEquals(first)) {
    return first.equals(second);
  }
  if (isValidElement(first) || isValidElement(second)) {
    return isEqual(first, second);
  }
  return void 0;
};
const isDeepEqual = (first, second) => isEqualWith(first, second, _isEqual);
export default isDeepEqual;
